module.exports = __webpack_public_path__ + "static/media/earnings.040fe01d.svg";